import React from "react";
import { IProjectId } from "../../Project.props";
import EditProject from "./EditProject";



const EditProjectIndex: React.FC<IProjectId> = ({ projectId ,setMethod}) => {

    return (
        <EditProject projectId={projectId} setMethod={setMethod}/>
    );
}

export default EditProjectIndex;
